<div class="flex-column table-grid-container" #gridDynamicHeight>
  <ag-grid-angular
    class="table-grid"
    #tableGrid
    [gridOptions]="gridOptions()"
    (gridReady)="gridReady($event)"
    [editType]="editType"
    (rowDataUpdated)="rowDataUpdated($event)"
    (gridSizeChanged)="onGridSizeChanged($event)"
    [maxBlocksInCache]="2"
    [columnTypes]="columnTypes"
    [rowBuffer]="0"
  />
</div>
